var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, "min-width": 200, fixed: false, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-text", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.edit,
                  expression: "edit",
                },
              ],
              ref: "input_" + scope.$index + "_" + "code",
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                "min-length": _vm.minLength,
                "max-length": _vm.maxLength,
                require: _vm.getRequire,
                rules: _vm.rules,
              },
              on: { onFieldChange: _vm.onFieldChange },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.edit,
                    expression: "!edit",
                  },
                ],
              },
              [
                _c("span", [_vm._v(_vm._s(scope.row[_vm.code]))]),
                _vm.errorSign[scope.$index]
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "right",
                        attrs: {
                          effect: "dark",
                          content: _vm.message[scope.$index],
                          placement: "top",
                        },
                      },
                      [
                        _c("div", [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: { color: "red" },
                          }),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }